import { Menu, X } from "lucide-react";
import logo from "../../../resources/Color variable-07.png";
import { Link } from "react-router-dom";

const LandingNav = ({ scrollToSection, setMobileMenuOpen, mobileMenuOpen }) => {
  return (
    <nav className="fixed top-0 left-0 right-0 bg-white backdrop-blur-xl border-b border-slate-200 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <img src={logo} className="object-contain md:h-12 h-9 w-auto" />

          <div className="hidden md:flex items-center gap-6">
            <button
              onClick={() => scrollToSection("features")}
              className="text-slate-600 hover:text-slate-900 font-medium transition-colors"
            >
              Características
            </button>
            <button
              onClick={() => scrollToSection("pricing")}
              className="text-slate-600 hover:text-slate-900 font-medium transition-colors"
            >
              Precios
            </button>
            <a
              href="/login"
              className="text-slate-600 hover:text-slate-900 font-medium transition-colors"
            >
              Iniciar sesión
            </a>
            <a
              href="/registrarse"
              className="px-5 py-2.5 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl font-medium hover:from-blue-700 hover:to-blue-800 transition-all shadow-lg shadow-blue-600/30 hover:shadow-xl hover:scale-105"
            >
              Comenzar Gratis
            </a>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 hover:bg-slate-100 rounded-lg"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden border-t border-slate-200 bg-white">
          <div className="px-4 py-4 space-y-3">
            <Link
              to={`/login`}
              className="block px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-lg"
            >
              Iniciar sesión
            </Link>
            <button
              onClick={() => scrollToSection("features")}
              className="block w-full text-left px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-lg"
            >
              Características
            </button>
            <button
              onClick={() => scrollToSection("pricing")}
              className="block w-full text-left px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-lg"
            >
              Precios
            </button>
            <Link
              to={`/registrarse`}
              className="block px-4 py-2 bg-blue-600 text-white text-center rounded-lg font-medium"
            >
              Comenzar Gratis
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default LandingNav;
